module.exports = __webpack_public_path__ + "static/media/video.53507eb0.mp4";